import React from "react";
// import { Input, Button, Table, Radio, List } from "antd";

class StepTwo extends React.Component {
  render() {
    return (
      <div className="analysis__step analysis__step_two">
        Step Two
      </div>
    );
  }
}

export default StepTwo;
